var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 27.3027H6M42 52.8027L49.5 45.3027L42 37.8027M30 37.8027L22.5 45.3027L30 52.8027M6 23.7027L6 48.9027C6 53.9432 6 56.4634 6.98094 58.3886C7.8438 60.0821 9.22063 61.4589 10.9141 62.3218C12.8393 63.3027 15.3595 63.3027 20.4 63.3027H51.6C56.6405 63.3027 59.1607 63.3027 61.0859 62.3218C62.7794 61.4589 64.1562 60.0821 65.0191 58.3886C66 56.4634 66 53.9432 66 48.9027V23.7027C66 18.6623 66 16.142 65.0191 14.2168C64.1562 12.5234 62.7794 11.1465 61.0859 10.2837C59.1607 9.30274 56.6405 9.30274 51.6 9.30274L20.4 9.30273C15.3595 9.30273 12.8393 9.30273 10.9141 10.2837C9.22063 11.1465 7.8438 12.5234 6.98094 14.2168C6 16.142 6 18.6623 6 23.7027Z",
    stroke: "#72C420",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService4);
export default __webpack_public_path__ + "static/media/service4.0cc42ac3c2f04b6be9ff7d5e961d0c5a.svg";
export { ForwardRef as ReactComponent };